import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const ContainerCircles = styled.div`
  position: absolute;
  left: 50%;
  bottom: 90px;
`;

// 2026-10-26 (docs/FORM-AUDIT-2026-10-26.md) — A BUTTON, with a name a screen reader says, where it was a round div with no role
// and no words: the shutter was the one control on the ID step a keyboard or VoiceOver could not reach. It looks the same.
const OuterCircle = styled.button`
  position: absolute;
  left: -37px;
  padding: 0;
  border: 0;
  cursor: pointer;

  height: 75px;
  width: 75px;

  /*
  opacity of 0.4
*/
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 50%;

  z-index: 1;
`;

// a span, the phrasing content a button may hold
const InnerCircle = styled.span`
  display: block;
  position: absolute;
  left: 50%;
  top: 38px;

  height: 44px;
  width: 44px;

  background: white;
  border-radius: 50%;

  /*
 Offset the position correctly with
 minus half of the width and minus half of the height
*/
  margin: -22px 0px 0px -22px;

  /*
  On the top of outer-circle
*/
  z-index: 2;
`;

const InnerCircleIsClicked = styled(InnerCircle)`
  height: 38px;
  width: 38px;
  margin: -19px 0px 0px -19px;
`;

export const CircleButton = ({
  onClick,
  isClicked,
  label = "Take the photo",
  disabled = false,
}: {
  onClick: () => void;
  isClicked: boolean;
  /** what a screen reader says it is, in the client's language */
  label?: string;
  /** 2026-10-26 — until the camera's first frame: a press before it took nothing and said nothing */
  disabled?: boolean;
}) => {
  return (
    <ContainerCircles>
      <OuterCircle
        type="button"
        aria-label={label}
        disabled={disabled}
        style={disabled ? { opacity: 0.5, cursor: "default" } : undefined}
        onClick={(e) => {
          if (!isClicked) {
            onClick();
          }
        }}
      >
        <InnerCircle as={isClicked ? InnerCircleIsClicked : InnerCircle} />
      </OuterCircle>
    </ContainerCircles>
  );
};

CircleButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isClicked: PropTypes.bool.isRequired,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

export default CircleButton;
